import cladding2 from "../../../assets/Cladding/cladding2.jpeg";
import cladding3 from "../../../assets/Cladding/cladding3.jpeg";
import cladding4 from "../../../assets/Cladding/cladding4.jpeg";
import cladding5 from "../../../assets/Cladding/cladding5.jpeg";
import cladding9 from "../../../assets/Cladding/cladding9.jpeg";
import cladding18 from "../../../assets/Cladding/cladding18.jpeg";
import cladding19 from "../../../assets/Cladding/cladding19.gif";
import cladding21 from "../../../assets/Cladding/cladding21.jpg";
import cladding22 from "../../../assets/Cladding/cladding22.jpg";
import cladding23 from "../../../assets/Cladding/cladding23.jpg";
import cladding24 from "../../../assets/Cladding/cladding24.jpg";
import cladding25 from "../../../assets/Cladding/cladding25.jpg";
import cladding26 from "../../../assets/Cladding/cladding26.jpg";
import cladding27 from "../../../assets/Cladding/cladding27.jpg";
import cladding29 from "../../../assets/Cladding/cladding29.jpg";
import cladding30 from "../../../assets/Cladding/cladding30.jpeg";
import cladding31 from "../../../assets/Cladding/cladding31.jpeg";
import cladding32 from "../../../assets/Cladding/cladding32.jpeg";
import cladding33 from "../../../assets/Cladding/cladding33.jpeg";
import cladding34 from "../../../assets/Cladding/cladding34.jpeg";

import eletric1 from "../../../assets/Eletric/eletric1.jpeg";
import eletric2 from "../../../assets/Eletric/eletric2.jpeg";
import eletric3 from "../../../assets/Eletric/eletric3.jpeg";
import eletric4 from "../../../assets/Eletric/eletric4.jpeg";
import eletric5 from "../../../assets/Eletric/eletric5.jpeg";
import eletric6 from "../../../assets/Eletric/eletric6.jpeg";
import eletric7 from "../../../assets/Eletric/eletric7.jpeg";

import hidraulic2 from "../../../assets/Hidraulic/hidraulic2.jpeg";
import hidraulic3 from "../../../assets/Hidraulic/hidraulic3.jpeg";
import hidraulic11 from "../../../assets/Hidraulic/hidraulic11.jpg";
import hidraulic12 from "../../../assets/Hidraulic/hidraulic12.jpg";
import hidraulic13 from "../../../assets/Hidraulic/hidraulic13.jpg";
import hidraulic14 from "../../../assets/Hidraulic/hidraulic14.jpg";
import hidraulic15 from "../../../assets/Hidraulic/hidraulic15.jpg";
import hidraulic16 from "../../../assets/Hidraulic/hidraulic16.jpg";
import hidraulic17 from "../../../assets/Hidraulic/hidraulic17.jpg";
import hidraulic18 from "../../../assets/Hidraulic/hidraulic18.jpg";
import hidraulic20 from "../../../assets/Hidraulic/hidraulic20.jpeg";
import hidraulic21 from "../../../assets/Hidraulic/hidraulic21.jpeg";
import hidraulic22 from "../../../assets/Hidraulic/hidraulic22.jpeg";
import hidraulic23 from "../../../assets/Hidraulic/hidraulic23.jpeg";
import hidraulic24 from "../../../assets/Hidraulic/hidraulic24.jpeg";
import hidraulic25 from "../../../assets/Hidraulic/hidraulic25.jpeg";

import lining1 from "../../../assets/Lining/lining1.jpeg";
import lining2 from "../../../assets/Lining/lining2.jpeg";
import lining3 from "../../../assets/Lining/lining3.jpeg";
import lining13 from "../../../assets/Lining/lining13.jpg";
import lining14 from "../../../assets/Lining/lining14.jpg";
import lining15 from "../../../assets/Lining/lining15.jpg";
import lining16 from "../../../assets/Lining/lining16.jpg";
import lining17 from "../../../assets/Lining/lining17.jpg";
import lining18 from "../../../assets/Lining/lining18.jpg";
import lining19 from "../../../assets/Lining/lining19.jpg";
import lining20 from "../../../assets/Lining/lining20.jpeg";
import lining21 from "../../../assets/Lining/lining21.jpeg";
import lining22 from "../../../assets/Lining/lining22.jpeg";
import lining23 from "../../../assets/Lining/lining23.jpeg";
import lining24 from "../../../assets/Lining/lining24.jpeg";

import painting2 from "../../../assets/Painting/painting2.jpeg";
import painting16 from "../../../assets/Painting/painting16.jpg";
import painting17 from "../../../assets/Painting/painting17.jpg";
import painting18 from "../../../assets/Painting/painting18.jpg";
import painting19 from "../../../assets/Painting/painting19.jpg";
import painting20 from "../../../assets/Painting/painting20.jpg";
import painting21 from "../../../assets/Painting/painting21.jpg";
import painting22 from "../../../assets/Painting/painting22.jpg";
import painting23 from "../../../assets/Painting/painting23.jpeg";
import painting24 from "../../../assets/Painting/painting24.jpeg";
import painting25 from "../../../assets/Painting/painting25.jpeg";
import painting26 from "../../../assets/Painting/painting26.jpeg";
import painting27 from "../../../assets/Painting/painting27.jpeg";
import painting28 from "../../../assets/Painting/painting28.jpeg";
import painting29 from "../../../assets/Painting/painting29.jpeg";

import project1 from "../../../assets/Projects/project1.jpeg";
import project2 from "../../../assets/Projects/project2.jpeg";
import project3 from "../../../assets/Projects/project3.jpeg";
import project4 from "../../../assets/Projects/project4.jpeg";
import project5 from "../../../assets/Projects/project5.jpeg";

const slidesPainting = () => {
  const slides = [
    painting2,
    painting16,
    painting17,
    painting18,
    painting19,
    painting20,
    painting21,
    painting22,
    painting23,
    painting24,
    painting25,
    painting26,
    painting27,
    painting28,
    painting29,
  ];
  return slides;
};

const slidesCladding = () => {
  const slides = [
    cladding2,
    cladding3,
    cladding4,
    cladding5,
    cladding9,
    cladding18,
    cladding19,
    cladding21,
    cladding22,
    cladding23,
    cladding24,
    cladding25,
    cladding26,
    cladding27,
    cladding29,
    cladding30,
    cladding31,
    cladding32,
    cladding33,
    cladding34,
  ];
  return slides;
};

const slidesEletric = () => {
  const slides = [
    eletric1,
    eletric2,
    eletric3,
    eletric4,
    eletric5,
    eletric6,
    eletric7,
  ];
  return slides;
};

const slidesHidraulic = () => {
  const slides = [
    hidraulic2,
    hidraulic3,
    hidraulic11,
    hidraulic12,
    hidraulic13,
    hidraulic14,
    hidraulic15,
    hidraulic16,
    hidraulic17,
    hidraulic18,
    hidraulic20,
    hidraulic21,
    hidraulic22,
    hidraulic23,
    hidraulic24,
    hidraulic25,
  ];
  return slides;
};

const slidesLining = () => {
  const slides = [
    lining1,
    lining2,
    lining3,
    lining13,
    lining14,
    lining15,
    lining16,
    lining17,
    lining18,
    lining19,
    lining20,
    lining21,
    lining22,
    lining23,
    lining24,
  ];
  return slides;
};

const slidesProjects = () => {
  const slides = [project1, project2, project3, project4, project5];
  return slides;
};

export {
  slidesEletric,
  slidesCladding,
  slidesPainting,
  slidesHidraulic,
  slidesLining,
  slidesProjects,
};
